const parseList = (value) => String(value || '')
  .split(',')
  .map((item) => item.trim())
  .filter(Boolean);

const normalize = (value) => String(value || '').trim().toLowerCase();

const listAllows = (list, value) => {
  if (!value) return false;
  const normalizedValue = normalize(value);
  return list.some((item) => item === '*' || normalize(item) === normalizedValue);
};

export const getAiAssistantAccessConfig = () => ({
  allowedPlayerIds: parseList(process.env.VUE_APP_AI_ASSISTANT_ALLOWED_PLAYER_IDS),
  allowedUsernames: parseList(process.env.VUE_APP_AI_ASSISTANT_ALLOWED_USERNAMES),
});

export const isAiAssistantAllowed = ({ playerId, username } = {}) => {
  const { allowedPlayerIds, allowedUsernames } = getAiAssistantAccessConfig();
  return listAllows(allowedPlayerIds, playerId) || listAllows(allowedUsernames, username);
};
